"use client";

import { useTranslations } from "next-intl";
import { EmailField } from "@/components/form-fields/phone-field";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSignup } from "./use-signup";

/** The newsletter sign-up form: first name (optional) and email, the words they agree to, and a hidden field that only robots fill. Sending it asks the person to confirm by email (double opt-in). */
export function SignupForm({ id }: { id: string }) {
  const t = useTranslations("publicBlog.newsletter");
  const { sent, busy, submit } = useSignup();
  if (sent) return <p role="status" className="text-sm">{t("sent")}</p>;
  return (
    <form className="flex flex-col gap-3" onSubmit={submit}>
      <Input name="firstName" maxLength={80} autoComplete="given-name" aria-label={t("firstName")} placeholder={t("firstName")} />
      <EmailField id={`${id}-email`} name="email" required placeholder={t("email")} />
      <input name="website" tabIndex={-1} autoComplete="off" aria-hidden className="hidden" />
      <p className="text-xs text-muted-foreground">{t("consentText")}</p>
      <div className="flex justify-end"><Button type="submit" disabled={busy}>{t("join")}</Button></div>
    </form>
  );
}
